<template>
  <div class="content-text">
    <h1>Политика конфиденциальности</h1>
    <h2>I. Общие положения</h2>
    <p>
      Настоящее Положение о политике конфиденциальности (далее — Положение)
      является официальным документом Компании, зарегистрированного по адресу:
      Адркс (далее - «Оператор») и определяет порядок обработки и защиты
      информации о физических лицах (далее — «Пользователи»), пользующихся
      сервисами, информацией, услугами сайта, расположенного на доменном имени
      домен (далее — Сайт).
    </p>
    <p>
      Соблюдение конфиденциальности важно для Оператора, ведь целью данной
      Политики конфиденциальности является обеспечение защиты прав и свобод
      человека и гражданина при обработке его персональных данных, в том числе
      защиты прав на неприкосновенность частной жизни, личную и семейную тайну,
      от несанкционированного доступа и разглашения.
    </p>
    <p>
      Мы разработали Политику конфиденциальности, которая описывает, как мы
      осуществляем обработку персональных данных — любые действия (операции) или
      совокупность действий (операций), совершаемых с использованием средств
      автоматизации или без использования таких средств с персональными данными,
      включая сбор, запись, систематизацию, накопление, хранение, уточнение
      (обновление, изменение), извлечение, использование, передачу
      (распространение, предоставление, доступ), обезличивание, блокирование,
      удаление, уничтожение персональных данных.
    </p>
    <p>
      Отношения, связанные с обработкой персональных данных и информации о
      пользователях Сайта, регулируются настоящим Положением, иными официальными
      документами Оператора и действующим законодательством РФ.
    </p>
    <p>
      Обработка персональных данных осуществляется нами на законной и
      справедливой основе, действуя разумно и добросовестно и на основе
      принципов:
    </p>
    <ul>
      <li>законности целей и способов обработки персональных данных;</li>
      <li>добросовестности;</li>
      <li>
        соответствия целей обработки персональных данных целям, заранее
        определенным и заявленным при сбореперсональных данных, а также
        полномочиям Оператора;
      </li>
      <li>
        соответствия объема и характера обрабатываемых персональных данных,
        способов обработки персональных данных целям обработки персональных
        данных.
      </li>
    </ul>

    <p>
      Настоящая Политика конфиденциальности регулирует любой вид обработки
      персональных данных и информации личного характера (любой информации,
      позволяющей установить личность, и любой иной информации, связанной с
      этим) о физических лицах, которые являются потребителями продукции или
      услуг Оператора.
    </p>
    <p>
      Настоящая Политика распространяется на обработку личных, персональных
      данных, собранных любыми средствами, как активными, так и пассивными, как
      через Интернет, так и без его использования, от лиц, находящихся в любой
      точке мира.
    </p>
    <h2>II. Сбор персональных данных</h2>
    <p>
      Целью обработки персональных данных является выполнения обязательств
      Оператора перед Пользователями в отношении использования Сайта и его
      сервисов.
    </p>
    <p>
      Обработка персональных данных пользователей осуществляется с согласия
      субъекта персональных данных на обработку его персональных данных.
    </p>
    <p>
      Под персональными данными понимается любая информация, относящаяся к прямо
      или косвенно определенному или определяемому физическому лицу (субъекту
      персональных данных) и которая может быть использована для идентификации
      определенного лица либо связи с ним.
    </p>
    <p>
      Мы можем запросить у Вас персональные данные в любой момент, когда Вы
      связываетесь с Оператором. Оператор может использовать такие данные в
      соответствии с настоящей Политикой конфиденциальности. Она также может
      совмещать такую информацию с иной информацией для целей предоставления и
      улучшения своих продуктов, услуг, информационного наполнения (контента) и
      коммуникаций.
    </p>
    <p>
      Ниже приведены некоторые примеры типов персональных данных, которые
      Оператор может собирать, и как мы можем использовать такую информацию.
    </p>
    <h3>Какие персональные данные мы собираем</h3>
    <p>Мы можем собирать различные данные/информацию, включая:</p>
    <ul>
      <li>имя и фамилию,</li>
      <li>дату рождения;</li>
      <li>почтовый адрес;</li>
      <li>номер телефона;</li>
      <li>адрес электронной почты;</li>
      <li>банковские реквизиты.</li>
    </ul>
    <p>
      Персональные данные могут также включать в себя дополнительно
      предоставляемые Пользователями по запросу Оператора в целях исполнения
      Оператором обязательств перед Пользователями, вытекающих из договора на
      оказание услуг. Оператор вправе, в частности, запросить у Пользователя
      копию документа, удостоверяющего личность, либо иного документа,
      содержащего имя, фамилию, фотографию Пользователя, а также иные
      дополнительные данные, которые, по усмотрению Оператора, будут являться
      необходимыми и достаточными для идентификации такого Пользователя и
      позволят исключить злоупотребления и нарушения прав третьих лиц.
    </p>
    <p>
      Когда Вы привлекаете к нашим мероприятиям и активностям других лиц или
      приглашаете их к коммуникациям с нами, Оператор может собирать
      предоставляемые Вами персональные данных об этих лицах, такую как: имя,
      фамилия, дата рождения, почтовый адрес, адрес электронной почты и номер
      телефона.
    </p>
    <p>
      При обработке персональных данных нами обеспечивается точность
      персональных данных, их достаточность, а в необходимых случаях и
      актуальность по отношению к целям обработки персональных данных.
    </p>
    <h2>III. Хранение и использование персональных данных</h2>
    <p>
      Персональные данные Пользователей хранятся исключительно на электронных
      носителях и обрабатываются с использованием автоматизированных систем, за
      исключением случаев, когда неавтоматизированная обработка персональных
      данных необходима в связи с исполнением требований законодательства.
    </p>
    <h3>Как мы используем Вашу персональную информацию</h3>
    <p>
      Собираемые нами персональные данные позволяют направлять Вам уведомления о
      новых продуктах, специальных предложениях и различных событиях. Они также
      помогают нам улучшать наши услуги, контент и коммуникации. Если Вы не
      желаете быть включенным в наш список рассылки, Вы можете в любое время
      отказаться от рассылки путём информирования нас по указанным контактам для
      обратной связи.
    </p>
    <p>
      Время от времени мы можем использовать Ваши персональные данные для
      отправки важных уведомлений, содержащих информацию об изменениях наших
      положений, условий и политик, а также подтверждающих размещенные Вами
      заказы и совершенные покупки. Поскольку такая информация важна для Ваших
      взаимоотношений с Оператором, Вы не можете отказаться от получения таких
      сообщений.
    </p>
    <p>
      Мы также можем использовать персональную информацию для внутренних целей,
      таких как: проведение аудита, анализ данных и различных исследований в
      целях улучшения продуктов и услуг Оператора, а также взаимодействие с
      потребителями.
    </p>
    <p>
      Если Вы принимаете участие в розыгрыше призов, конкурсе или похожем
      стимулирующем мероприятии, мы сохраняем за собой право использовать
      предоставляемые Вами персональные данные для управления такими
      программами.
    </p>
    <h3>Сбор и использование информации, не являющейся персональной</h3>
    <p>
      Мы также собираем персональные данные, не являющиеся персональными −
      данные, не позволяющие прямо ассоциировать их с каким-либо определённым
      лицом. Мы можем собирать, использовать, передавать и раскрывать
      информацию, не являющуюся персональной, для любых целей.
    </p>
    <p>
      Мы можем собирать персональные данные, такие как: сведения о роде занятий,
      языке, почтовом индексе, уникальном идентификаторе устройства,
      местоположении и временной зоне, в которой используется тот или иной
      продукт, для того чтобы лучше понимать поведение потребителей и улучшать
      наши продукты, услуги и коммуникации.
    </p>
    <p>
      Мы можем также собирать персональные данные/информацию о том, чем
      интересуется пользователь на нашем веб-сайте при использовании других
      наших продуктов и сервисов. Такие персональные данные/информация
      собирается и используется для того, чтобы помочь нам предоставлять более
      полезную информацию нашим покупателям и для понимания того, какие элементы
      нашего сайта, продуктов и услуг наиболее интересны. Для целей настоящей
      Политики конфиденциальности совокупные данные рассматриваются как
      данные/информация, не являющиеся персональными.
    </p>
    <p>
      Если мы совмещаем информацию, не являющуюся персональной, с персональной
      информацией, такая совокупная информация будет рассматриваться как
      персональная информация, пока такая информация будет являться совмещённой.
    </p>
    <h2>IV. Передача персональных данных</h2>
    <p>
      Персональные данные Пользователей не передаются каким-либо третьим лицам,
      за исключением случаев, прямо предусмотренных настоящими Правилами.
    </p>
    <p>
      Обработка персональных данных Пользователя осуществляется без ограничения
      срока, любым законным способом, в том числе в информационных системах
      персональных данных с использованием средств автоматизации или без
      использования таких средств.
    </p>
    <p>
      Пользователь соглашается с тем, что Оператор вправе передавать
      персональные данные третьим лицам, в частности, курьерским службам,
      организациями почтовой связи, операторам электросвязи и т.д.,
      исключительно для целей, указанных в разделе «Сбор персональных данных»
      настоящей Политики конфиденциальности.
    </p>
    <p>
      При указании пользователя или при наличии согласия пользователя возможна
      передача персональных данных Пользователя третьим лицам-контрагентам
      Оператора с условием принятия такими контрагентами обязательств по
      обеспечению конфиденциальности полученной информации, в частности, при
      использовании приложений.
    </p>
    <p>
      Приложения, используемые Пользователями на Сайте, размещаются и
      поддерживаются третьими лицами (разработчиками), которые действуют
      независимо от Оператора и не выступают от имени или по поручению
      Оператора. Пользователи обязаны самостоятельно ознакомиться с правилами
      оказания услуг и политикой защиты персональных данных таких третьих лиц
      (разработчиков) до начала использования соответствующих приложений.
    </p>
    <p>
      Персональные данные Пользователя могут быть переданы по запросам
      уполномоченных органов государственной власти РФ только по основаниям и в
      порядке, установленным законодательством РФ.
    </p>
    <p>
      Оператор осуществляет блокирование персональных данных, относящихся к
      соответствующему Пользователю, с момента обращения или запроса
      Пользователя или его законного представителя либо уполномоченного органа
      по защите прав субъектов персональных данных на период проверки, в случае
      выявления недостоверных персональных данных или неправомерных действий.
    </p>
    <h3>Раскрытие информации третьими лицами</h3>
    <p>
      В некоторых случаях Оператор может предоставлять определенную персональную
      информацию и данные стратегическим партнерам, которые работают с
      Оператором для предоставления продуктов и услуг, или тем из них, которые
      помогают Оператору реализовывать продукты и услуги потребителям. Мы
      предоставляем третьим лицам минимальный объем персональных данных,
      необходимый только для оказания требуемой услуги или проведения
      необходимой транзакции.
    </p>
    <p>
      Персональная информация будет предоставляться Оператором только в целях
      обеспечения потребителей продуктами и услугами, а также для улучшения этих
      продуктов и услуг, связанных с ними коммуникаций. Такая информация не
      будет предоставляться третьим лицам для их маркетинговых целей.
    </p>
    <p>
      Для использования Ваших персональных данных для любой иной цели мы
      запросим Ваше Согласие на обработку Ваших персональных данных.
    </p>
    <h3>Поставщики услуг</h3>
    <p>
      Оператор предоставляет персональные данные/информацию компаниям,
      оказывающим такие услуги, как: обработка информации, предоставление
      кредитов, исполнение заказов потребителей, доставка, иные виды
      обслуживания потребителей, определение вашего интереса к нашим продуктам и
      услугам, проведение опросов, направленных на изучение наших потребителей
      или удовлетворения качеством сервиса. Такие компании обязуются защищать
      Вашу информацию независимо от страны своего расположения.
    </p>
    <h3>Иные лица</h3>
    <p>
      Оператору может быть необходимо — в соответствии с законом, судебным
      порядком, в судебном разбирательстве и/или на основании публичных запросов
      или запросов от государственных органов на территории или вне территории
      страны Вашего пребывания — раскрыть Ваши персональные данные. Мы также
      можем раскрывать персональные данные/информацию о Вас, если мы определим,
      что такое раскрытие необходимо или уместно в целях национальной
      безопасности, поддержания правопорядка или иных общественно важных
      случаях.
    </p>
    <p>
      Мы также можем раскрывать персональные данные/информацию о Вас, если мы
      определим, что раскрытие необходимо для приведения в исполнение наших
      положений и условий либо для целей защиты нашей деятельности и наших
      пользователей. Дополнительно в случае реорганизации, слияния или продажи
      мы можем передать любую или всю собираемую нами персональную информацию
      соответствующему третьему лицу.
    </p>
    <h2>V. Уничтожение персональных данных</h2>
    <p>
      Персональные данные пользователя уничтожаются при отзыве субъектом
      персональных данных согласия на обработку персональных данных.
    </p>
    <h2>VI. Защита персональных данных</h2>
    <p>
      Оператор предпринимает меры предосторожности — включая правовые,
      организационные, административные, технические и физические — для
      обеспечения защиты Ваших персональных данных в соответствии со ст. 19
      Федерального закона от 27.07.2006 N 152-ФЗ «О персональных данных» в целях
      обеспечения защиты персональных данных Пользователя от неправомерного или
      случайного доступа к ним, уничтожения, изменения, блокирования,
      копирования, распространения, а также от иных неправомерных действий
      третьих лиц.
    </p>
    <p>
      Когда Вы используете некоторые продукты, услуги или приложения Оператора
      или размещаете записи на форумах, в чатах или социальных сетях,
      предоставляемые Вами персональные данные видны другим пользователям и
      могут быть прочитаны, собраны или использованы ими. Вы несёте
      ответственность за персональные данные, которые Вы предпочитаете
      предоставлять, в таких случаях самостоятельно.
    </p>
    <h3>Целостность и сохранение персональной информации</h3>
    <p>
      Взаимодействуя с Оператором, Вы можете легко поддерживать свои
      персональные данные и информацию в актуальном состоянии. Мы будем хранить
      Ваши персональные данные и информацию в течение срока, необходимого для
      выполнения целей, описываемых в настоящей Политике конфиденциальности, за
      исключением случаев, когда более длительный период хранения данных и
      информации необходим в соответствии с законодательством либо разрешён им.
    </p>
    <p>
      Мы не собираем персональные данные о несовершеннолетних. Если нам станет
      известно о том, что мы получили персональные данные о несовершеннолетнем,
      мы предпримем меры для удаления такой информации в максимально короткий
      срок.
    </p>
    <p>
      Мы настоятельно рекомендуем родителям и иным лицам, под чьим присмотром
      находятся несовершеннолетние (законные представители — родители,
      усыновители или попечители), контролировать использование
      несовершеннолетними веб-сайтов.
    </p>
    <h3>Сторонние сайты и услуги</h3>
    <p>
      Веб-сайты, продукты, приложения и услуги Оператора могут содержать ссылки
      на веб-сайты, продукты и услуги третьих лиц. Наши продукты и услуги могут
      также использовать или предлагать продукты или услуги третьих лиц.
      Персональные данные и информация, собираемая третьими лицами, которые
      могут включать такие сведения, как данные местоположения или контактная
      информация, регулируется правилами соблюдения конфиденциальности таких
      третьих лиц. Мы призываем Вас изучать правила соблюдения
      конфиденциальности таких третьих лиц.
    </p>
    <p>
      Оператор не несет ответственности за действия третьих лиц, получивших в
      результате использования Интернета или Услуг Сайта доступ к информации о
      Пользователе и за последствия использования данных и информации, которые,
      в силу природы Сайта, доступны любому пользователю сети Интернет.
    </p>
    <h3>Соблюдение вашей конфиденциальности на уровне Компании</h3>
    <p>
      Для того чтобы убедиться, что Ваши персональные данные находятся в
      безопасности, мы доводим нормы соблюдения конфиденциальности и
      безопасности до работников Компании и строго следим за исполнением мер
      соблюдения конфиденциальности внутри Компании.
    </p>
    <h2>VII. Обращения пользователей</h2>
    <p>
      К настоящей Политике конфиденциальности и отношениям между Пользователем и
      Оператором применяется действующее законодательство РФ.
    </p>
    <p>
      Пользователи вправе направлять Оператору свои запросы, в том числе запросы
      относительно использования их персональных данных, направления отзыва
      согласия на обработку персональных данных в письменной форме по адресу,
      указанному разделе Общие положения настоящего положения, или в форме
      электронного документа, подписанного квалифицированной электронной
      подписью в соответствии с законодательством РФ.
    </p>
    <p>
      Оператор обязуется рассмотреть и направить ответ на поступивший запрос
      Пользователя в течение 30 дней с момента поступления обращения.
    </p>
    <h3>Другое</h3>
    <p>
      Во всем остальном, что не отражено напрямую в Политике Конфиденциальности,
      Оператор обязуется руководствоваться нормами и положениями Федерального
      закона от 27.07.2006 N 152-ФЗ «О персональных данных».
    </p>
    <p>
      Посетитель сайта Оператора, предоставляющий свои персональные данные и
      информацию, тем самым соглашается с положениями данной Политики
      конфиденциальности.
    </p>
    <p>
      Оператор оставляет за собой право вносить любые изменения в Политику в
      любое время по своему усмотрению с целью дальнейшего совершенствования
      системы защиты от несанкционированного доступа к сообщаемым Пользователями
      персональным данным без согласия Пользователя. Когда мы вносим
      существенные изменения в Политику конфиденциальности, на нашем сайте
      размещается соответствующее уведомление вместе с обновлённой версией
      Политики конфиденциальности.
    </p>
    <p>
      Действие настоящей Политики не распространяется на действия и
      интернет-ресурсов третьих лиц.
    </p>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
};
</script>

<style lang="scss" scoped>
@mixin font_t($size, $lineHeight) {
  font-size: #{$size}px !important;
  line-height: #{$lineHeight}px !important;
  @include _1170 {
    font-size: calc_fluid($size - ($size / 4), $size, 320, 1920) !important;
    line-height: calc_fluid(
      $lineHeight - ($lineHeight / 4),
      $lineHeight,
      320,
      1920
    ) !important;
  }
}
.content-text {
  flex: 1;
  padding: 20px 40px;
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: -16px;
  & h1,
  h2,
  h3,
  h4,
  caption {
    font-weight: bold;
    color: $base;
    width: 100%;
  }
  & h2,
  h3,
  h4 {
    margin-top: 24px;
  }
  & p {
    color: $base;
    font-size: calc_fluid(14, 16, 320, 1920);
    line-height: calc_fluid(21, 24, 320, 1920);
    margin-bottom: 16px;
    width: 100%;
  }
  & span {
    color: $base;
    font-size: calc_fluid(14, 16, 320, 1920);
    line-height: calc_fluid(21, 24, 320, 1920);
  }
  & img {
    width: 100% !important;
    object-fit: contain;
  }
  & h1 {
    margin-bottom: 28px;
    @include font_t(38, 43);
  }
  & h2 {
    @include font_t(31, 40);
    margin-bottom: 24px;
  }
  & h3 {
    @include font_t(28, 36);
    margin-bottom: 20px;
  }
  & h4 {
    @include font_t(28, 36);
    margin-bottom: 20px;
  }
  & ol,
  ul {
    padding-left: 20px;
    margin-bottom: 16px;
    width: 100%;
    & > li {
      width: 100%;
      margin-top: 12px;
      color: $base;
      font-size: calc_fluid(14, 16, 320, 1920);
      line-height: calc_fluid(19, 22, 320, 1920);
      &:first-child {
        margin-top: 0;
      }
    }
  }
  & ol {
    & > li {
      list-style-type: decimal;
    }
  }
  & ul {
    & > li {
      position: relative;
      padding-left: 9px;
    }
  }
  & a {
    color: #eb5757 !important;
    text-decoration: underline;
    &:hover {
      color: #eb5757 !important;
      text-decoration: none;
    }
    &:visited {
      color: #7a33d4 !important;
      text-decoration: underline;
    }
  }
}
</style>
